import convertToArray from './convertToArray';
import StopScroll from './StopScroll';

class ToolDialog {
  init() {
    this.doc = document;
    this.detailDialogAttr = 'data-detail-dialog';
    this.detailDialog = convertToArray(this.doc.querySelectorAll(`[${this.detailDialogAttr}]`));
    this.detailActiveClass = 'is_active';
    this.detailDialogLen = this.detailDialog.length;
    this.closeDetailBtnAttr = 'data-close-detail';
    this.openPaymentBtnAttr = 'data-open-payment';
    this.paymentDialog = this.doc.getElementById('paymentDialog');
    this.paymentActiveClass = 'is_active';
    this.paymentHiddenClass = 'is_hidden';
    this.closePaymentBtn = this.doc.getElementById('closePaymentBtn');
    this.paymentRadioBtn = convertToArray(this.paymentDialog.querySelectorAll('input[name="paymentRadioBtn"]'));
    this.paymentRadioBtnLen = this.paymentRadioBtn.length;
    this.creditCardInfo = this.doc.getElementById('creditCardInfo');
    this.creditCardInfoActiveClass = 'is_active';
    this.creditCardInfoInput = convertToArray(this.creditCardInfo.querySelectorAll('input, select'));
    this.creditCardInfoInputLen = this.creditCardInfoInput.length;
    this.invoiceAddress = this.doc.getElementById('invoiceAddress');
    this.invoiceAddressActiveClass = 'is_active';
    this.invoiceAddressInput = convertToArray(this.invoiceAddress.querySelectorAll('input'));
    this.invoiceAddressInputLen = this.invoiceAddressInput.length;
    this.submitPaymentBtn = this.doc.getElementById('submitPaymentBtn');
    this.confirmDialog = this.doc.getElementById('confirmDialog');
    this.confirmActiveClass = 'is_active';
    this.closeConfirmBtn = this.doc.getElementById('closeConfirmBtn');
    this.submitConfirmBtn = this.doc.getElementById('submitConfirmBtn');
    this.completeDialog = this.doc.getElementById('completeDialog');
    this.completeActiveClass = 'is_active';
    this.closeCompleteBtn = this.doc.getElementById('closeCompleteBtn');
    this.backdrop = this.doc.getElementById('backdrop');
    this.backdropActiveClass = 'is_active';
    this.openDetail = this.openDetail.bind(this);
    this.closeDetail = this.closeDetail.bind(this);
    this.openPayment = this.openPayment.bind(this);
    this.backToDetail = this.backToDetail.bind(this);
    this.openConfirm = this.openConfirm.bind(this);
    this.backToPayment = this.backToPayment.bind(this);
    this.openComplete = this.openComplete.bind(this);
    this.closeComplete = this.closeComplete.bind(this);
    this.controlPaymentForm = this.controlPaymentForm.bind(this);
    this.stopScroll = new StopScroll();
  }
  start() {
    this.openDetailBtnAttr = 'data-open-detail';
    this.openDetailBtn = convertToArray(document.querySelectorAll(`[${this.openDetailBtnAttr}]`));
    this.openDetailBtnLen = this.openDetailBtn.length;
    if (!this.openDetailBtnLen) return;
    this.init();
    for (let bi = 0; bi < this.openDetailBtnLen; bi += 1) {
      this.openDetailBtn[bi].addEventListener('click', this.openDetail);
    }
  }
  openDetail(e) {
    const current = e.currentTarget;
    const category = current.getAttribute(this.openDetailBtnAttr);
    for (let di = 0; di < this.detailDialogLen; di += 1) {
      const target = this.detailDialog[di];
      if (target.getAttribute(this.detailDialogAttr) === category) {
        this.openedDetail = target;
        this.openedDetail.classList.add(this.detailActiveClass);
        this.closeDetailBtn = this.openedDetail.querySelector(`[${this.closeDetailBtnAttr}]`);
        this.closeDetailBtn.addEventListener('click', this.closeDetail);
        this.openPaymentBtn = this.openedDetail.querySelector(`[${this.openPaymentBtnAttr}]`);
        this.openPaymentBtn.addEventListener('click', this.openPayment);
        this.backdrop.classList.add(this.backdropActiveClass);
        this.backdrop.addEventListener('click', this.closeDetail);
      }
    }
    this.stopScroll.stop();
  }
  closeDetail() {
    this.resetDetail();
    this.backdrop.classList.remove(this.backdropActiveClass);
    this.stopScroll.reStart();
  }
  resetDetail() {
    this.openedDetail.classList.remove(this.detailActiveClass);
    this.closeDetailBtn.removeEventListener('click', this.closeDetail);
    this.backdrop.removeEventListener('click', this.closeDetail);
    this.openedDetail = null;
    this.closeDetailBtn = null;
  }
  hideDetail() {
    this.openedDetail.classList.remove(this.detailActiveClass);
    this.backdrop.removeEventListener('click', this.closeDetail);
  }
  openPayment() {
    this.hideDetail();
    this.paymentDialog.classList.add(this.paymentActiveClass);
    for (let pri = 0; pri < this.paymentRadioBtnLen; pri += 1) {
      this.paymentRadioBtn[pri].disabled = false;
      this.paymentRadioBtn[pri].addEventListener('change', this.controlPaymentForm);
    }
    this.closePaymentBtn.addEventListener('click', this.backToDetail);
    this.submitPaymentBtn.addEventListener('click', this.openConfirm);
    this.backdrop.addEventListener('click', this.backToDetail);
  }
  closePayment() {
    this.paymentDialog.reset();
    for (let pri = 0; pri < this.paymentRadioBtnLen; pri += 1) {
      this.paymentRadioBtn[pri].disabled = true;
      this.paymentRadioBtn[pri].removeEventListener('change', this.controlPaymentForm);
    }
    this.paymentDialog.classList.remove(this.paymentActiveClass);
    this.paymentDialog.classList.remove(this.paymentHiddenClass);
    this.closePaymentBtn.removeEventListener('click', this.backToDetail);
    this.submitPaymentBtn.removeEventListener('click', this.openConfirm);
    this.backdrop.removeEventListener('click', this.backToDetail);
    this.disableCardInfo();
    this.disableInvoiceAddress();
  }
  backToDetail() {
    this.closePayment();
    this.openedDetail.classList.add(this.detailActiveClass);
    this.backdrop.addEventListener('click', this.closeDetail);
  }
  hidePayment() {
    this.paymentDialog.classList.add(this.paymentHiddenClass);
    this.backdrop.removeEventListener('click', this.backToDetail);
  }
  openConfirm() {
    this.hidePayment();
    this.confirmDialog.classList.add(this.confirmActiveClass);
    this.closeConfirmBtn.addEventListener('click', this.backToPayment);
    this.submitConfirmBtn.addEventListener('click', this.openComplete);
    this.backdrop.addEventListener('click', this.backToPayment);
  }
  closeConfirm() {
    this.confirmDialog.classList.remove(this.confirmActiveClass);
    this.closeConfirmBtn.removeEventListener('click', this.backToPayment);
    this.submitConfirmBtn.removeEventListener('click', this.openComplete);
    this.backdrop.removeEventListener('click', this.backToPayment);
  }
  backToPayment() {
    this.closeConfirm();
    this.paymentDialog.classList.remove(this.paymentHiddenClass);
    this.backdrop.addEventListener('click', this.backToDetail);
  }
  openComplete() {
    this.resetDetail();
    this.closePayment();
    this.closeConfirm();
    this.completeDialog.classList.add(this.completeActiveClass);
    this.closeCompleteBtn.addEventListener('click', this.closeComplete);
    this.backdrop.addEventListener('click', this.closeComplete);
  }
  closeComplete() {
    this.completeDialog.classList.remove(this.completeActiveClass);
    this.backdrop.classList.remove(this.backdropActiveClass);
    this.closeCompleteBtn.removeEventListener('click', this.closeComplete);
    this.backdrop.removeEventListener('click', this.closeComplete);
    this.stopScroll.reStart();
  }
  controlPaymentForm(e) {
    const flg = e.target.id;
    if (flg === 'paymentRadioCreditCard') {
      this.disableInvoiceAddress();
      this.ableCardInfo();
    } else if (flg === 'paymentRadioInvoice') {
      this.disableCardInfo();
      this.ableInvoiceAddress();
    } else {
      this.disableCardInfo();
      this.disableInvoiceAddress();
    }
  }
  ableCardInfo() {
    this.creditCardInfo.classList.add(this.creditCardInfoActiveClass);
    for (let ci = 0; ci < this.creditCardInfoInputLen; ci += 1) {
      this.creditCardInfoInput[ci].disabled = false;
    }
  }
  disableCardInfo() {
    this.creditCardInfo.classList.remove(this.creditCardInfoActiveClass);
    for (let ci = 0; ci < this.creditCardInfoInputLen; ci += 1) {
      this.creditCardInfoInput[ci].disabled = true;
    }
  }
  ableInvoiceAddress() {
    this.invoiceAddress.classList.add(this.invoiceAddressActiveClass);
    for (let ai = 0; ai < this.invoiceAddressInputLen; ai += 1) {
      this.invoiceAddressInput[ai].disabled = false;
    }
  }
  disableInvoiceAddress() {
    this.invoiceAddress.classList.remove(this.invoiceAddressActiveClass);
    for (let ai = 0; ai < this.invoiceAddressInputLen; ai += 1) {
      this.invoiceAddressInput[ai].disabled = true;
    }
  }
}
export default ToolDialog;



// WEBPACK FOOTER //
// ./src/js/module/ToolDialog.js